import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SubtleBadge from 'components/common/SubtleBadge';
import CountUp from 'react-countup';

const EstimatedCost = ({ stat }) => {
  const {
    title,
    value,
    decimal,
    suffix,
    prefix,
    valueClassName,
    badgeText,
    badgeBg
  } = stat;
  return (
    <>
      <h6>
        {title}
        {badgeText && (
          <SubtleBadge bg={badgeBg} pill className="ms-2">
            {badgeText}
          </SubtleBadge>
        )}
      </h6>
      <div
        className={classNames(
          valueClassName,
          'display-4 fs-5 mb-2 fw-normal font-sans-serif'
        )}
      >
        <CountUp
          start={0}
          end={value}
          duration={2.75}
          suffix={suffix}
          prefix={prefix}
          separator=","
          decimals={decimal ? 2 : 0}
          decimal="."
        />
      </div>
    </>
  );
};

EstimatedCost.propTypes = {
  stat: PropTypes.shape({
    title: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    decimal: PropTypes.bool,
    suffix: PropTypes.string,
    prefix: PropTypes.string,
    valueClassName: PropTypes.string,
    linkText: PropTypes.string,
    link: PropTypes.string,
    badgeText: PropTypes.string,
    badgeBg: PropTypes.string,
    image: PropTypes.string,
    className: PropTypes.string
  })
};

export default EstimatedCost;
